// Dont touch the following constants, we use constant because chrome extension is not able to read env variables
export const isProd = process.env.REACT_APP_ENVIRONMENT === 'production';
export const BASE_URL = process.env.REACT_APP_SERVER_BASE_URL;
export const SSO_BASE_URL = isProd
  ? 'https://api.stytch.com/v1/public/sso/start'
  : 'https://test.stytch.com/v1/public/sso/start';
export const GOOGLE_AUTH_B2B_BASE_URL = isProd
  ? 'https://api.stytch.com/v1/b2b/public/oauth/google/discovery/start'
  : 'https://test.stytch.com/v1/b2b/public/oauth/google/discovery/start';
export const MICROSOFT_AUTH_B2B_BASE_URL = isProd
  ? 'https://api.stytch.com/v1/b2b/public/oauth/microsoft/discovery/start'
  : 'https://test.stytch.com/v1/b2b/public/oauth/microsoft/discovery/start';
export const DEFAULT_AGENT_NAME = 'Dokai';
